// ES6 polyfill
import 'babel-polyfill';

// requestAnimationFrame polyfill
import 'requestanimationframe';

// Custom modernizr configuration
import './libs/modernizr';

// 99designs global navigation
require(['common/components/globalNav'], createGlobalNav => {
    createGlobalNav.default();
});



// WEBPACK FOOTER //
// ./js/common/vendor.js